import { SpaceDocumentLimits } from 'types/space';

/**
 * Default security + durability limits for Space documents, seeded from the prior
 * `surface-templates/validationHelpers.ts` limits (100 components / 500KB) and tuned per the
 * red/green corpus. Changing these is a reviewed code change with corpus updates — not a
 * dynamic config knob.
 */
export const DEFAULT_SPACE_DOCUMENT_LIMITS: SpaceDocumentLimits = {
  maxComponents: 100,
  maxPayloadBytes: 500 * 1024,
  maxNestingDepth: 16,
  maxPostExpansionComponents: 500,
};
